// @flow

import './index.scss';
import * as React from 'react';
import Button from 'components/Button';
import Icon from 'components/Icon';
import classnames from 'classnames';
import { useTranslate } from '@insolus/react-i18n';

import type { Ad } from 'stores/api/ads';

type Props = {|
    ad: Ad,
    isMobile: boolean
|};

const CallButton = ({ ad, isMobile }: Props): React.Node => {
    const { __ } = useTranslate();

    const [displayPhone, setDisplayPhone] = React.useState<boolean>(false);

    const handleClick = React.useCallback(() => {
        setDisplayPhone(true);
    }, []);

    const className = classnames('CallButton', {
        'CallButton--show': displayPhone
    });

    if (isMobile) {
        return (
            <Button
                className={className}
                type="primary"
                to={`tel:${ad.phoneArea} ${ad.phoneNumber}`}
            >
                <Icon type="phone" />
                {__('call-advertiser')}
            </Button>
        );
    }

    return (
        <Button
            className={className}
            type="primary"
            onClick={handleClick}
        >
            <Icon type="phone" />
            {displayPhone ? `${ad.phoneArea.replace('++', '+')}${ad.phoneNumber.toString().indexOf(' ') >= 0 ? ' ' : ''}${ad.phoneNumber}` : __('call-advertiser')}
        </Button>
    );
};

export default CallButton;
